import { Stack, type SxProps, type Theme } from "@mui/material";

export interface NotificationListProps {
  children: React.ReactNode[];
  sx?: SxProps<Theme>;
}

export function NotificationList(props: NotificationListProps) {
  const { children, sx } = props;

  return (
    <Stack spacing={3} sx={sx}>
      {children}
    </Stack>
  );
}
